import React from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
} from "@mui/material";
import PermIdentityOutlinedIcon from '@mui/icons-material/PermIdentityOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { useForm } from 'react-hook-form';
import { useRef } from 'react'
import emailjs from '@emailjs/browser';
import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import './TravelForm.css'
function TravlForm() {
    const { t } = useTranslation()

    const form = useRef()
    const { register, handleSubmit, reset } = useForm();
    const sendEmail = (e) => {
        // e.preventDefault();
        emailjs.sendForm('service_0g79k1i', 'template_rom7s17', form.current, 'j6vn0YyFK2SG7x2SY')
            .then((result) => {
                console.log(result.text);
                enqueueSnackbar("Data sent successfully👍")
                reset()
            }, (error) => {
                console.log(error.text);
                enqueueSnackbar(error, { variant: 'error' });
                reset()
            });
        reset()
    }
    // const onSubmit = data => console.log(data);
    return (
        <Box sx={{ width: { md: "100%", xs: "100%" } }}>
            <Typography
                variant="h5"
                component="h3"
                sx={{
                    mb: 5,
                    fontWeight: "bold",
                    maxWidth: 600,
                    fontSize: '1.5rem'
                }}>
                {t("contactMe.contactUsDesc")}
            </Typography>
            <Box component="form" gap={20} ref={form} onSubmit={handleSubmit(sendEmail)} mt={1} name="from_name" >
                <Box display={"flex"} gap={2} alignItems={"center"}>
                    <PermIdentityOutlinedIcon />
                    <Typography
                        variant="h6"
                        component="h3"
                        sx={{
                            mb: 1,
                            maxWidth: 600,
                            fontSize: '1.5rem'
                        }}
                    >
                        {t("contactMe.FullName")}
                    </Typography>
                </Box>
                <TextField
                    placeholder={t("contactMe.FullName")}
                    fullWidth
                    name="name"
                    // onChange={(e) => setPhone(e.target.value)}
                    {...register("name", { required: true })}
                    required
                    sx={{
                        mb: 1,
                        backgroundColor: "#FFF",
                        fontSize: '1.5rem'
                    }}
                />
                <Box display={"flex"} gap={2} alignItems={"center"}>
                    <LocalPhoneIcon />
                    <Typography
                        variant="h6"
                        component="h3"
                        sx={{
                            mb: 1,
                            maxWidth: 600,
                            fontSize: '1.5rem'
                        }}>
                        {t("contactMe.phone")}
                    </Typography>
                </Box>
                <TextField
                    fullWidth
                    placeholder={t("contactMe.phone")}
                    required
                    name="phone"
                    {...register("phone", { required: true })}
                    // onChange={(e) => setCountry(e.target.value)}
                    sx={{
                        mb: 1,
                        backgroundColor: "#FFF",
                        fontSize: '1.5rem'
                    }}
                >
                </TextField>

                <Box display={"flex"} gap={2} alignItems={"center"}>
                    <ForumOutlinedIcon />
                    <Typography
                        variant="h6"
                        component="h3"
                        sx={{
                            mb: 1,
                            maxWidth: 600,
                            fontSize: '1.5rem'
                        }}
                    >
                        {t("contactMe.message")}
                    </Typography>
                </Box>
                <TextField
                    fullWidth
                    placeholder={t("contactMe.message")}
                    name="message"
                    required
                    {...register("message", { required: true })}
                    // onChange={(e) => setCity(e.target.value)}
                    sx={{
                        mb: 1,
                        backgroundColor: "#FFF",
                        fontSize: '1.5rem'
                    }}
                />

                <br />
                <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    color="secondary"
                    size="large"
                    sx={{
                        mt: 1,
                        mb: 1,
                        color: "white",
                        fontSize: 18,
                    }}
                >
                    {t("contactMe.sendMessage")}
                </Button>
            </Box>
        </Box>
    );
}

export default TravlForm;
